export let BACKEND_URL_PROD = 'https://api.carepassport.ca/';
export let FRONTEND_URL_PROD = 'https://www.carepassport.ca/';

export let BACKEND_URL_STAG = 'https://carepassport-server-staging.azurewebsites.net/';
export let FRONTEND_URL_STAG = 'https://qa.care-ltc.ca/';

console.log("Environment : ", process.env.REACT_APP_ENV)

export var BASE_API_URL = process.env.REACT_APP_ENV === 'production' ? BACKEND_URL_PROD : (process.env.REACT_APP_ENV === 'staging') ? BACKEND_URL_STAG : "http://localhost:4000/";
export var BASE_URL_FRONTEND = process.env.REACT_APP_ENV === 'production' ? FRONTEND_URL_PROD : (process.env.REACT_APP_ENV === 'staging') ? FRONTEND_URL_STAG : 'http://localhost:3000/';

//only changes for production build in package.json
//"start": "node server.js",
//"start-react": "react-scripts start",
//For dev
////"start": "react-scripts start",